import { Timezone } from "@nlc/shared-types";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

type TimezoneConverterParams = {
  format?: string;
  timezone: null | string;
  type: "dateFormat" | "fromNow";
  utcDate: null | string;
};

export const timezoneConverter = ({
  format = "DD/MM/YYYY HH:mm",
  timezone,
  type,
  utcDate,
}: TimezoneConverterParams): string => {
  if (!utcDate) return "";

  const targetTimezone = timezone || Timezone.EST;

  if (type === "fromNow") {
    return dayjs.utc(utcDate).tz(targetTimezone).fromNow();
  }

  return dayjs.utc(utcDate).tz(targetTimezone).format(format);
};

export const convertUTCtoEastern = (
  utcDate: null | string | undefined,
  format = "MMM D, YYYY",
): string => {
  if (!utcDate) return "";

  return dayjs.utc(utcDate).tz(Timezone.EST).format(format);
};

export const convertUTCtoEasternRelative = (
  utcDate: null | string | undefined,
): string => {
  if (!utcDate) return "";

  return dayjs.utc(utcDate).tz(Timezone.EST).fromNow();
};
